import PilsClient from './clients/PilsClient';
import CartQtyText from './pils-components/cart-qty-text';
import pilsTypes from './pils-components/pils-types';
import ToDefaultShoppingListToggle from './pils-components/to-default-shopping-list-toggle';
import ToWatchListButton from './pils-components/to-watch-list-toggle';

class PilsComponents
{
    constructor()
    {
        this.client = new PilsClient();
        this.productNumbers = [];
        this.defaultShoppingListId = null;
        this.data = {};

        this.components = {};
        this.componentsExist = false;
    }

    async init()
    {
        this.defaultShoppingListId = orion.getDefaultShoppingListId();

        this.initComponents();

        this.reinit();
    }

    async reinit()
    {
        if (!this.componentsExist) return;

        this.productNumbers = this.fetchProductNumbers();

        this.data = await this.fetchData();

        this.delegateUpdate('all');
    }

    async fetchData()
    {
        return this.client.fetchQtyOnLists(this.productNumbers)
            .then((response) => response.json());
    }

    initComponents()
    {
        let componentConfigs = [
            {
                type: pilsTypes.cart,
                selector: '.js-cart-qty-text',
                ComponentClass: CartQtyText,
                args: []
            },
            {
                type: pilsTypes.shopping_list,
                selector: '.js-to-default-shopping-list-toggle',
                ComponentClass: ToDefaultShoppingListToggle,
                args: [this.defaultShoppingListId]
            },
            {
                type: pilsTypes.watchlist,
                selector: '.js-to-watch-list-toggle',
                ComponentClass: ToWatchListButton,
                args: []
            }
        ];

        componentConfigs.forEach(config =>
        {
            this.components[config.type] = [];

            const elements = document.querySelectorAll(config.selector);
            elements.forEach(element =>
            {
                this.componentsExist = true;
                this.components[config.type].push(
                    new config.ComponentClass(element, ...config.args)
                );
            });
        });
    }

    initEvents()
    {
        // We need to use jQuery here because vanilla JS cannot listen to JQuery events.

        let $body = $('body');

        $body.on(
            orion.constants.EventProductListReloaded,
            this.init.bind(this)
        );

        $body.on(
            orion.constants.EventTilesviewVariationChanged,
            this.reinit.bind(this)
        );

        $body.on(
            orion.constants.EventCartProductCreated,
            async() =>
            {
                if (this.componentsExist)
                {
                    this.data = await this.fetchData();
                    this.delegateUpdate(pilsTypes.cart);
                }
            }
        );

        $body.on(
            [
                orion.constants.EventShoppingListProductDeleted,
                orion.constants.EventShoppingListProductCreated,
                orion.constants.EventShoppingListProductUpdated
            ].join(' '),
            async() =>
            {
                if (this.componentsExist)
                {
                    this.data = await this.fetchData();
                    this.delegateUpdate(pilsTypes.shopping_list);
                }
            }
        );
    }

    delegateUpdate(listType)
    {
        if (listType !== 'all' && !Object.prototype.hasOwnProperty.call(pilsTypes, listType))
        {
            console.log('Unknown list type <' + listType + '>');
            return;
        }

        switch (listType)
        {
        case 'all':
            this.updateAll();
            break;
        default:
            this.updateComponentByListType(listType);
            break;
        }
    }

    updateAll()
    {
        for (const [, components] of Object.entries(this.components))
        {
            components.forEach(component =>
            {
                component.update(this.data);
            });
        }
    }

    updateComponentByListType(listType)
    {
        this.components[listType].forEach(component =>
        {
            component.update(this.data);
        });
    }

    fetchProductNumbers()
    {
        let productNumbers = {};

        for (const [, components] of Object.entries(this.components))
        {
            components.forEach(component =>
            {
                if (!productNumbers[component.productNumber])
                {
                    productNumbers[component.productNumber] = true;
                }
            });
        }

        return Object.keys(productNumbers);
    }
}

const pilsComponents = new PilsComponents();
pilsComponents.init();
pilsComponents.initEvents();
